import { gql } from '@apollo/client';
import { getPCodeMasterListQuery, orderFragments, nextErrorFragment } from 'next-common';

export const getPCodeMasterListQueryParsed = gql`
  ${getPCodeMasterListQuery}
`;

export const togglePcodesOnOrderMutationParsed = gql`
  mutation togglePcodesOnOrder($orderId: ID!, $input: [PCodesInput!]!) {
    togglePcodesOnOrder(orderId: $orderId, input: $input) {
      ...order
      ...nextError
    }
  }
  ${orderFragments}
  ${nextErrorFragment}
`;
